import { styled } from '../../theme/styled';

export const List = styled.ul`
  display: grid;
  grid-template-columns: 1fr;
  @media ${({ theme }) => theme.device.mobileL} {
    grid-template-columns: 1fr 1fr;
  }
  gap: ${({ theme }) => theme.sizes.normal};
  margin-bottom: ${({ theme }) => theme.sizes.normal};
  padding-inline-start: 0;
`;

export const ListItem = styled.li`
  border-radius: ${({ theme }) => theme.roundedCorners.xsmall};
  border: 1px solid ${({ theme }) => theme.configuration.strokeColor};
  min-height: 5.625rem;
  list-style-type: none;
  &:hover {
    border-color: ${({ theme }) => theme.configuration.primaryColor};
  }
`;

export const ListItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.sizes.xsmall};
`;

export const StyledButton = styled.button`
  padding: ${({ theme }) => theme.sizes.normal};
  width: 100%;
  background: transparent;
  border: 0;
  font-family: ${(props) => props.theme.font.face};
  text-align: left;
  &:hover {
    cursor: pointer;
  }
`;
